<template>
	<div class="modal-mask">
		<!-- container -->
		<div id="container" class="privacy_page">
		<div class="container_wrap">
			<div class="content_inner">
			<div class="close_btn">
				<span @click="$emit('closePop', '1')">
					<img src="@/assets/images/close_icon.jpg" alt="닫기" />
				</span>
			</div>
			<div class="con_wrap">
				<p class="comm_tit">제3자 정보 이용 동의</p>
				<div class="textbox">
				<p class="commp">셀비체크업 프리미엄 리포트를 {{ getCompanyName }}의 FC 를 통해 전달드리기 위해 아래 정보 제공에 대한  동의가 필요합니다.<br/> </p>
				</div>
				<div class="textbox">
				<p class="m_tit">[개인정보 제3자 제공 동의]</p>
				<p class="commp">  셀바스에이아이(이하 "회사"라 한다)는 인공지능 기반 건강 분석 리포트 서비스 제공 과정에서 아래와 같이
				귀하의 개인정보를 제3자에게 제공합니다. 아래의 내용을 확인 후 동의하여 주세요.<br /><br/>
				정보를 제공받는 자 : {{ getCompanyName }} <br/> </p>
				</div>
				<div class="textbox">
				<p class="commp">
				제공받는 이용목적 : 셀비체크업 건강 분석 리포트에 따른 고객 맞춤형 보장 분석 및 보험 가입 상담<br />
				제공 내용 : 셀비체크업 건강 분석 리포트 (발병통계지수, 건강나이 등)
				<br/><br/>
				개인정보 보유기간 : 개인정보 보안법 제 39조의 6 (개인정보의 파기에 대한 특례) 에 의거 제공되는 건강 분석 리포트는 1회 출력 한 후 즉시 파기. <br/>
				보유 및 이용 기간 : 관련 법령 상 보존의무가 있는 경우가 아닌 한 담당 컨설턴트의 회원 탈퇴 시 또는 서비스 이용 동의 철회 시까지 보유 및 이용 <br/><br/>
				귀하는 위와 같은 개인정보의 제3자 제공에 대한 동의를 거부할 권리가 있으며, 동의를 거부할 경우 받는 별도의 불이익이 없습니다. 단, 서비스 이용이 불가능하거나, 서비스 이용 목적에 따른 서비스 제공에 제한이 따르게 됩니다. <br/>
				</p>
				</div>
			</div>
			</div>
		</div>
		<!--//container_wrap-->
		</div>
		<!-- //container -->
	</div>
</template>

<script>
import { mapGetters } from "vuex"
import sessionStorage from '@/utils/sessionStorage'
import api from "@/utils/apiCaller"

export default {
	data() {
		return {
			siteInfo: null
		}
	},
	computed: {
		...mapGetters("user", {
			getUser: "getUser"
		}),
		getCompanyName() {
			if(this.siteInfo) {
				return this.siteInfo.name
			}
			return ''
		}
	},
	methods: {
		async getSiteInfo() {
			const param = {
				authToken: this.getUser.authToken,
				siteId: this.getUser.siteId
			}
			const res  = await api.sign.getSiteInfo(param)
			if(Number(res.data.code) === 200) {
				this.siteInfo = res.data.result.site
			}
			else {
				await alert('알 수 없는 오류가 발생했습니다.')
				this.goIntro()
			}
		},
		goIntro() {
			const pathType = sessionStorage.pathType.get('routePath')
			if (pathType) {
				this.$router.push(pathType)
			} else {
				this.$router.push('/Intro')
			}
		}
	},
	mounted() {
		this.getSiteInfo()
	}
}
</script>

<style scoped>
.modal-mask {
	position: fixed;
	z-index: 9998;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: white;
	overflow-y: scroll;
}

.privacy_page .content_inner {
	/* max-width: 768px; */
	width: 100%;
	margin: 0 auto;
}

.privacy_page .close_btn {
	height: 72px;
	line-height: 72px;
	text-align: right;
	/* max-width: 768px; */
	width: 100%;
	padding: 0 30px;
	box-sizing: border-box;
	margin: 0 auto;
}

.privacy_page .close_btn img {
	vertical-align: middle;
}

.comm_tit {
	font-size: 24px;
	font-weight: bold;
	color: #202020;
	font-family: "Spoqa Han Sans";
}

.privacy_page .comm_tit {
	margin-top: 20px;	
}

.privacy_page .textbox {
	margin-top: 40px;
}

.privacy_page .commp {
	font-size: 14px;
	color: #202020;
	font-weight: normal;
	font-family: "Spoqa Han Sans";
	margin-bottom: 20px;
}

.m_tit {
	font-size: 20px;
	font-weight: bold;
	color: #202020;
	font-family: "Spoqa Han Sans";
}

.privacy_page .m_tit {
	margin-bottom: 30px;
	}

.privacy_page .mcommp {
	margin-bottom: 20px;
}

@media screen and (max-width: 960px) {
	.privacy_page .con_wrap {
		padding: 0 30px;
		box-sizing: border-box;
	}
}
.commp .p20 {
	padding-left: 20px;
}
</style>
